import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const subTextColor = useColorModeValue('gray.600', 'gray.400');
  const bgCard = useColorModeValue('white', 'whiteAlpha.100');
  const inputBgColor = useColorModeValue('white', 'whiteAlpha.50');
  const supplierBgColor = useColorModeValue('gray.100', 'whiteAlpha.200');
  const headingBgColor = useColorModeValue('white', 'navy.800');

  return {
    backgroundCardColor,
    textColor,
    borderColor,
    subTextColor,
    bgCard,
    inputBgColor,
    supplierBgColor,
    headingBgColor,
  };
};
